import { useTranslation } from 'react-i18next';

import { PageHeader } from '../../../shared/ui/PageHeader';
import { Spinner } from '../../../shared/ui/Spinner';
import { useAdminAccounts } from '../hooks/useAdminAccounts';
import { AdminAccountsTable } from '../components/AdminAccountsTable';
import { CreateAdminForm } from '../components/CreateAdminForm';
import styles from './AdminsPage.module.css';

// PARA-114, AC-1/AC-2/AC-3/AC-4.
export function AdminsPage(): JSX.Element {
  const { t } = useTranslation();
  const { data, isLoading } = useAdminAccounts();

  return (
    <section>
      <PageHeader title={t('admins.title')} />
      {isLoading || !data ? (
        <Spinner />
      ) : (
        <div className={styles.stack}>
          <CreateAdminForm />
          <AdminAccountsTable admins={data} />
        </div>
      )}
    </section>
  );
}
